module.exports = __webpack_public_path__ + "static/media/20.9040259f.jpg";